import React from 'react'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { RacingTitle } from '@mobi/betslip/Components/Common/BetCard/Components/EventDetails/Components/RacingTitle'
import { CountdownStatus } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/Details/Components/SelectionInfo/Components/Multi/Components/CountdownStatus/CountdownStatus'
import type { TicketLeg } from '@core/Areas/Account/Pages/Activity/types'

export const FallbackRaceHeader = ({ leg }: { leg: TicketLeg }) => {
  return (
    <BetCard.EventDetails
      statusComponent={<CountdownStatus multiLeg={leg} />}
      heading={
        <RacingTitle
          races={[{ raceNumber: leg.raceNumber }]}
          meetingName={leg.meetingName}
          isMultipleRaceSelection={false}
        />
      }
    />
  )
}
